



































import {Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { CardColor } from '@share/common/cards/types/CardColor';
import TopPart from "./components/top/SessionCardTop.vue";
import CardFooter from "./components/footer/SessionCardFooter.vue";
import { contains } from "@service/helpers/domHelper";
import { RouteNamesEnum } from '@service/router/RouteNamesEnum';
import { getSessionTypeColor } from '@common/ProfileColor';
import TimeCardBase from '../cards/time-card/TimeCardBase.vue';
import { AgendaModel } from '@api/models/agenda/AgendaModel';
import { AxiosResponse } from 'axios';

@Component({
    components: { TopPart, CardFooter }
})
export default class SessionCard extends TimeCardBase {
    @Prop({ default: CardColor.blue }) color: CardColor;
    @Prop() declare source: AgendaModel;
    @Prop() partner: Element | undefined;

    @Inject() deleteCardItem: (id: string) => Promise<AxiosResponse<any>> | undefined;

    play(event: MouseEvent) {
        const $footer = (this.$refs.footer as Vue | undefined)?.$el as HTMLElement | null;

        if(!contains($footer, event.target as HTMLElement)) {
            this.$emit('play', this.source);
        }
    }

    toEdit(id: string) {
        this.$router.push({
            name: RouteNamesEnum.sessionEdit,
            params: {
                id: id,
                sessionType: "",
                eventId: this.$route.params.eventId,
                backend: this.$route.params.backend
            }
        })
    }

    async deleteItem() {
        const deleteResponse = await this.deleteCardItem(this.source.id);

        if(deleteResponse) {
            this.deleted = true;
        }
    }

    get categoryStyles() {
        return {
            color: getSessionTypeColor(this.type)
        }
    }

    get type() {
        return this.source.type || this.$t(`program.sessionWithoutArticle`).toString()
    }

    get colorClass() {
        switch (this.color as CardColor) {
            case CardColor.blue:
                return this.base_class + '_blue';
            case CardColor.darkBlue:
                return this.base_class + '_dark-blue';

            default:
                return this.base_class + '_blue';
        }
    }

    get speakers() {
        return this.source.speakers || [];
    }
}

